module.exports = __webpack_public_path__ + "Flag-148.beec434fafc70b13bf32038e0e6b0ef4.svg";